module.exports = __webpack_public_path__ + "static/media/icon_l.46d6c023.svg";